module.exports = __webpack_public_path__ + "img/icon-sb-white-glove-160x106.85d3dce.svg";